module.exports = "https://cdn-challenge.mathletics.com/app/280/assets/images/4f6c1126d3155b37e0e493b37624536e.svg";